module.exports = __webpack_public_path__ + "static/media/30-5.731d7d7d.mp3";